import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import MendConfigListing from './MendConfigListing'
import MendCredentialsForm from './MendCredentialsForm'

export default function MendPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={MendCredentialsForm}
            PullConfigListingView={MendConfigListing}
        />
    )
}